export default function acDateField() {
    function parseDate(date) {
        if (date instanceof Date) {
            // the datepicker returns a JS Date object, with hours, minutes and timezone
            // in order to convert it back to date, we must remove the timezone, then
            // remove hours and minutes
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

            let dateString = date.toJSON();
            return dateString ? dateString.substr(0,10) : null;
        }
        return date;
    }

    return {
            scope: {
                'name': '@',
                'value': '=',
                'required': '@',
                'format': '@'
            },
            restrict: 'E',
            link: function(scope, element) {
                // TODO: get format from translations
                if (!scope.format) {
                    scope.format = "dd/MMyyyy";
                }

                scope.$watch('rawValue', function(newRawValue) {
                    if(newRawValue === undefined){
                        // ui bootstrap datepicker set value to undefined
                        // when the value is invalid and null if empty
                        return;
                    }
                    const newValue = parseDate(newRawValue);

                    if (!angular.equals(scope.value, newValue)) {
                        scope.value = newValue;
                    }
                });

                scope.toggleDatePicker = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.isOpen = !scope.isOpen;
                };
            },
            template:
    `<div class="input-group datepicker">
        <input
            type="text" ng-model="rawValue" id="{{ name }}" name="{{ name }}" class="form-control"
            uib-datepicker-popup="{{ format }}" is-open="isOpen" ng-required="{{ required }}"
            close-text="{{ 'CLOSE' | translate }}" clear-text="{{ 'CLEAR' | translate }}" current-text="{{ 'CURRENT' | translate }}"/>
        <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="toggleDatePicker($event)">
                <i class="glyphicon glyphicon-calendar"></i>
            </button>
        </span>
    </div>
    `
    };
};

acDateField.$inject = [];



// WEBPACK FOOTER //
// ./js/fields/acDataField.js